{
  "instances": {
    "jolokia": {
      "label": "JMX",
      "close": "Ljúka",
      "domains": "Lén",
      "execute": "Framkvæma",
      "executing": "Framkvæma…",
      "execution_failed": "Framkvæmd mistekist.",
      "execution_successful": "Framkvæmd farsæl.",
      "mbeans": "MBeans"
    }
  }
}
